import React from 'react';
import AboutYourEarnings from './about-your-earnings';
import Card from 'src/components/cards/card';
import CollapsibleSection from 'src/components/collapsible-section';

interface Props {
  amount: number;
  name: string;
  aboutEarningsText?: string;
}

const AboutYourEarningsCard = ({amount = 0, name, aboutEarningsText}: Props) => (
  <Card>
    <CollapsibleSection
      title="About Your Earnings"
      trackIdentifier="college-listing-requirements-about-your-earnings"
    >
      <div className="college-profile-card-content">
        <AboutYourEarnings amount={amount} name={name} aboutEarningsText={aboutEarningsText} />
      </div>
    </CollapsibleSection>
  </Card>
);

export default AboutYourEarningsCard;
